import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsProtectedFromSyncCheckbox.module.scss';

interface IProps {
	toggleIsProtectedFromSync: () => void;
	isTaxPercentProtectedFromSync: boolean;
}

export const IsProtectedFromSyncCheckbox: React.FC<IProps> = React.memo(
	({ toggleIsProtectedFromSync, isTaxPercentProtectedFromSync }) => {
		return (
			<Form.Item className={style.container} name="isProtectedFromSync" data-test="IsProtectedFromSyncCheckbox">
				<Checkbox onChange={toggleIsProtectedFromSync} checked={isTaxPercentProtectedFromSync}>
					<Text translationNameSpace="form" translationKey="protectFromSyncLabel" asFragment={true} />
				</Checkbox>
			</Form.Item>
		);
	},
);
